export default __webpack_public_path__ + "static/media/cert-of-insurance.5d4bc262.jpg";